import { Component } from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';


@Component({
  selector: 'app-standing-order-renderer',
  templateUrl: './standing-order-render.component.html',
  styleUrls: ['./standing-order-render.component.scss']
})
export class StandingOrderRenderer implements ICellRendererAngularComp {
  
  private params: any;
  showBtn = false;

  agInit(params: any): void {
    this.params = params;

    if(this.params.value) {
      this.showBtn = false;
    } else {
      this.showBtn = true;
    }
  }

  /**
   * @description
   * @returns {boolean}
   */
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/standing-order-render/standing-order-render.component.ts